import { QuoteSelector } from "components/QuoteSelector";
import { PaperQuote } from "store/slices/citedPapers";

interface FloatingQuoteSelectorProps {
  quotes: PaperQuote[];
  selectedQuote?: number;
  onSelectQuote: (index: number) => void;
  citation?: number;
}

/**
 * FloatingQuoteSelector - Wrapper component that positions QuoteSelector as a floating element
 * Used in PaperSidebarDrawer components for bottom-centered positioning
 */
export default function FloatingQuoteSelector({
  quotes,
  selectedQuote,
  onSelectQuote,
  citation,
}: FloatingQuoteSelectorProps) {
  if (!quotes || quotes.length === 0) {
    return null;
  }

  return (
    <div className="absolute right-0 left-0 bottom-3 z-10 mt-3">
      <div className="flex justify-center">
        <div className="bg-bg-base border border-border-subtle rounded-xl p-1.5">
          <QuoteSelector
            quotes={quotes}
            selectedQuote={selectedQuote}
            onSelectQuote={onSelectQuote}
            citation={citation}
          />
        </div>
      </div>
    </div>
  );
}
